var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenezuela(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#091e79",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7cf46",
    d: "M30 8H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf2c30",
    d: "M30 24H0v-8h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.2 13.72-.18-.65-.23.63-.67-.02.53.41-.23.63.56-.37.53.41-.19-.64.56-.38zm1.26-1.68.1-.67-.47.49-.6-.3.31.6-.47.48.66-.12.32.6.1-.67.66-.11zm1.73-1.24.28-.62-.58.34-.5-.45.14.65-.59.34.67.07.14.66.28-.61.67.06zm1.84-.97-.31-.6-.1.67-.66.12.6.3-.09.66.47-.48.6.3-.31-.6.47-.48zm7.32 4.26.53-.41-.67.02-.23-.63-.19.64-.67.03.56.38-.19.64.53-.41.56.37zm-1.34-1.57.66.12-.47-.48.32-.6-.6.3-.48-.49.1.67-.6.3.66.11.09.67zm-1.62-1.39.67-.07-.59-.34.14-.65-.5.45-.58-.34.27.62-.5.44.67-.06.28.61zM16.38 9.9l-.1-.66-.31.6-.67-.12.47.48-.31.6.6-.3.47.48-.1-.66.6-.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenezuela);
export default __webpack_public_path__ + "static/media/venezuela.e2ab7726a54a21c34b26a856ab2e2c4e.svg";
export { ForwardRef as ReactComponent };